import { useQueryClient } from '@tanstack/react-query';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { ModelDetails, ModelsUploadUrlData, UpdateModelBody } from '../types';

export function useModelDetails(modelId: string) {
  const queryClient = useQueryClient();

  const { isFetching, data } = useApiQuery<ModelDetails>(
    `/models/${modelId}`,
    {
      queryKey: ['modelDetails', modelId],
      initialData: null,
    }
  );

  const uploadUrlDataMutation = useApiMutation<void, ModelsUploadUrlData>(
    '/models/upload-url',
    {
      method: 'GET',
    }
  );

  const updateModelMutation = useApiMutation<UpdateModelBody, ModelDetails>(
    '/models',
    {
      method: 'PATCH',
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(['modelDetails', modelId], data);
      },
    }
  );

  return {
    isFetching,
    details: data,
    uploadUrlDataMutation,
    updateModelMutation,
  } as const;
}
